// extracted by mini-css-extract-plugin
export default {"signup_btn":"signup_signup_btn__ZEBGx","main":"signup_main__Klw+c","form":"signup_form__Nzvw3","back":"signup_back__HyloZ"};